import { StyleSheet, Text, View } from 'react-native'
import React from 'react'
import { IBGeneralTable } from '../../../../../../common'
import { IBService, InvestmentDataInfo } from '../../../../../../ib-service'
import { useTranslation } from 'react-i18next'
import { useLoading } from '@mxt/zio-react'
import { isNil, orderBy } from 'lodash'
import { pipe } from 'fp-ts/lib/function'
import { ZIO } from '@mxt/zio'
import moment from 'moment'
interface Props {
  investmentInfo?: InvestmentDataInfo
  policyNumber: string
  setInvestmentInfo: (data: InvestmentDataInfo) => void
  productType: string
}
export const AllocatedPremiumInfo = (props: Props) => {
  const { t, i18n } = useTranslation('Inbound')
  const { investmentInfo, policyNumber, setInvestmentInfo, productType } = props
  const [loading, bindLoading] = useLoading()

  React.useEffect(() => {
    if (isNil(investmentInfo?.allocatedPremiumInfo)) {
      const accountingCodes = [{ sacsCode: 'LE', sacsType: 'IV' }]
      pipe(
        IBService.ACMVQuery(policyNumber, 'GET_ACCOUNTING_HISTORY_BY_CODE', undefined, accountingCodes, true),
        ZIO.map((res) => {
          setInvestmentInfo({
            ...(investmentInfo as InvestmentDataInfo),
            allocatedPremiumInfo: res.data?.map((item) => ({
              ...item,
              accountingAmount: item.moneySign === '-' ? (item.accountingAmount || 0) * -1 : item.accountingAmount
            }))
          })
        }),
        bindLoading,
        ZIO.unsafeRun({})
      )
    } else {
      pipe(ZIO.succeed(investmentInfo), bindLoading, ZIO.unsafeRun({}))
    }
  }, [])

  const dataTable = [
    {
      label: t('EffectiveDate'),
      field: 'effectiveDate',
      format: 'date'
    },
    { label: t('TransNo'), field: 'transNo' },
    { label: t('TransactionDate'), field: 'transDate', format: 'date' },
    {
      label: t('Code'),
      field: 'transCode'
    },
    {
      label: t('AccountingAmount'),
      field: 'accountingAmount',
      format: 'money'
    }
  ]
  return (
    <View>
      <IBGeneralTable
        data={
          orderBy(
            investmentInfo?.allocatedPremiumInfo?.map((item) => ({
              ...item,
              effectiveDate: moment(item.effectiveDate, 'DD/MM/YYYY').format('YYYYMMDD'),
              transDate: moment(item.transDate, 'DD/MM/YYYY').format('YYYYMMDD')
            })),
            ['transDate', 'transNo'],
            ['desc', 'desc']
          ) || []
        }
        dataTable={dataTable}
        loading={loading}
        autoPaging
      />
    </View>
  )
}

const styles = StyleSheet.create({})
